const WINTER_MONTHS = [11, 12, 1, 2];

export const getSeason = () => {
  const forced = new URLSearchParams(window.location.search).get('season');
  if (forced === 'winter' || forced === 'summer') sessionStorage.setItem('pbnj_season', forced);
  const saved = sessionStorage.getItem('pbnj_season');
  if (saved === 'winter' || saved === 'summer') return saved;
  const month = Number(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', month: 'numeric' }).format(new Date()));
  return WINTER_MONTHS.includes(month) ? 'winter' : 'summer';
};

const IMG = (id, w = 900) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}`;

const CARDS = {
  winterizing: { icon: 'Snowflake', title: 'Winterizing & Freeze Protection', img: IMG('photo-1542730876-206eabda479f'),
    text: 'Protect your system before the next hard freeze. We shut down, drain and insulate so pipes, valves and your backflow device survive Texas cold snaps.',
    points: ['System shut-down & drain', 'Backflow & valve insulation', 'Freeze-damage repair', 'Spring start-up check'] },
  repair: { icon: 'Wrench', title: 'Sprinkler Repair', img: IMG('photo-1622122123829-e0490a288d04'),
    text: "Broken heads, leaks, dead zones or a valve that won't shut off — we find the problem fast and fix it right.",
    points: ['Broken & leaking heads', 'Valve & wiring repair', 'Line breaks & leaks', 'Coverage adjustments'] },
  installation: { icon: 'Sprout', title: 'New Installations', img: IMG('photo-1767533427586-436b683f34ef'),
    text: 'Efficient sprinkler systems designed for your yard, installed cleanly and set up to save water.',
    points: ['Custom zone design', 'Quality heads & valves', 'Controller setup', 'Backflow installed & tested'] },
  tuneup: { icon: 'Gauge', title: 'Start-Up & Tune-Ups', img: IMG('photo-1567365171506-9e7a2258a658'),
    text: 'Get every zone running right for the hot months — we check pressure, coverage and timer settings so your lawn stays green without wasting water.',
    points: ['Spring system start-up', 'Head & nozzle adjustment', 'Leak & pressure check', 'Watering schedule setup'] },
};

export const SEASONS = {
  winter: {
    theme: 'is-winter', snow: true, anchor: 'winterizing', navLabel: 'Winterizing',
    heroImg: IMG('photo-1642576073557-1a64e64f4a83', 1920),
    eyebrow: 'Winter Season · Waxahachie & DFW',
    title: 'Sprinkler Repair, Installs & Winter Freeze Protection',
    lead: 'Get your irrigation system ready for the cold — and ready to thrive in spring. Licensed, insured, and local.',
    alertIcon: 'Snowflake', alertTitle: "Hard freeze coming? Don't wait for a cracked pipe.",
    alertText: 'One freezing night can split valves and backflow devices. Book winterizing now — and if it already froze, we repair freeze damage too.',
    alertCta: 'Protect My System', servicesTitle: 'Sprinkler services built for Texas winters',
    services: ['winterizing', 'repair', 'installation'],
  },
  summer: {
    theme: 'is-summer', snow: false, anchor: 'tune-ups', navLabel: 'Tune-Ups',
    heroImg: IMG('photo-1770664945615-52203ab54c88', 1920),
    eyebrow: 'Summer Season · Waxahachie & DFW',
    title: 'Sprinkler Repair & New Installations',
    lead: 'Keep your lawn green through the Texas heat with a system that works right. Licensed, insured, and local.',
    alertIcon: 'Sun', alertTitle: 'Brown spots or a high water bill?',
    alertText: 'A broken head or hidden leak can waste thousands of gallons a month. We find it, fix it, and tune your system for summer.',
    alertCta: 'Fix My System', servicesTitle: 'Sprinkler services built for Texas summers',
    services: ['repair', 'installation', 'tuneup'],
  },
};

export const serviceCard = (id) => ({ id, ...CARDS[id] });
